import { prefixLanguage } from '@/js/helpers/url'
// префикс апи
export const API_BASE_URL = '/api/v1/'
export const BASE_URL = window.location.origin
export const prefixAPI = (url, model = '') => prefixLanguage(API_BASE_URL + model + url)
export const baseAPI = url => `${BASE_URL + prefixLanguage(url)}`
